import { Component } from '@angular/core';
import { FooterLink } from './footer-link/footer-link.interface';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  links: FooterLink[] = [
    {
      title: 'Central de Atendimento',
      description: '0800 880 1900',
    },
    {
      title: 'Whatsapp',
      description: '(51) 9 9528 0140',
    },
    {
      title: 'Ouvidoria',
      description: '0800 880 1999',
    },
    {
      title: 'SUSEP',
      description: '0800 021 8484',
    },
    {
      title: 'E-mail',
      description: 'sac@sabemi.com.br',
    },
    {
      title: 'Canal de ',
      linkDescription: 'Denúncias',
      link:
        'https://sabemi.becompliance.com/canal-etica/canal-denuncias?origin=$2y$10$.ft8lL.H2/FSAX.IqUl3POjiLPMpwXZPRxFQfPdtxZnfvNwl5uvFa',
    },
    {
      title: 'Guia',
      linkDescription: 'Portal do Cliente',
      link: 'https://www.sabemi.com.br/Media/2yob4awm/guia-portal-do-cliente-ok-site.pdf',
    },
  ];
}
